import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestBoeDetails extends WorkrequestDetailsBase {
  selectedOptionText: string;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/boe-form/workrequest-boe-details.ts